// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3zWue","globe":"Loading_globe__3EtDd","rotation":"Loading_rotation__3mYoQ"};